export default {
	computed: {
		baseUrl() {
			const url = "http://hldapi.sctengsen.net/";
			return url;
		},
		innerWidth() {
			return window.innerWidth;
		},
	},
	methods: {},
};
